import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import { ref } from 'vue';
import { useMainStore } from '~/stores/mainStore';
import type { ITokenModel } from '~/types/apiService';
import useTokensDataCache from '~/composables/useTokensDataCache';

export default () => {
  const store = useMainStore();
  const { address } = useWeb3ModalAccount();
  const { getTokenData, getCachedData } = useTokensDataCache();

  const isLoading = ref(false);
  const currentTokenInfoData = ref<ITokenModel | null>();

  const tokenBalance = ref('');
  const tokenStakedBalance = ref('');
  const blackPearlBalance = ref('');
  const blackPearlStakedBalance = ref('');
  const totalStaked = ref('');
  const stakedPercent = ref('');
  const aprPercent = ref('');
  const earnedBalance = ref('');

  async function updateData(forceRefresh = false): Promise<void> {
    if (!address.value) {
      return;
    }

    const cached = getCachedData(store.currentToken);
    if (cached && !forceRefresh) {
      currentTokenInfoData.value = cached.currentTokenInfo;
      tokenBalance.value = cached.tokenBalance;
      blackPearlBalance.value = cached.blackPearlBalance;
      tokenStakedBalance.value = cached.tokenStakedBalance;
      blackPearlStakedBalance.value = cached.blackPearlStakedBalance;
      totalStaked.value = cached.totalStaked;
      stakedPercent.value = cached.stakedPercent;
      aprPercent.value = cached.aprPercent;
      earnedBalance.value = cached.earnedBalance;
    }

    isLoading.value = true;

    try {
      const tokenData = await getTokenData(store.currentToken, forceRefresh);

      currentTokenInfoData.value = tokenData.currentTokenInfo;
      tokenBalance.value = tokenData.tokenBalance;
      blackPearlBalance.value = tokenData.blackPearlBalance;
      tokenStakedBalance.value = tokenData.tokenStakedBalance;
      blackPearlStakedBalance.value = tokenData.blackPearlStakedBalance;
      totalStaked.value = tokenData.totalStaked;
      stakedPercent.value = tokenData.stakedPercent;
      aprPercent.value = tokenData.aprPercent;
      earnedBalance.value = tokenData.earnedBalance;
    } catch (err) {
      console.log('err: ', err);
    } finally {
      isLoading.value = false;
    }
  }

  return {
    isLoading,
    updateData,
    tokenBalance,
    tokenStakedBalance,
    blackPearlBalance,
    blackPearlStakedBalance,
    totalStaked,
    stakedPercent,
    aprPercent,
    earnedBalance,
    currentTokenInfoData
  };
};
